/**
 * Author: David Schiefer
 * Department: ITS Development Tax

 * Property definition od the action btns
 * Since the nature of buttons is to live often in component where you want to pass the props to it
 * the properties are defined separate, so you can simply add them to the property of another component if needed
 *
 */

import type {TBtnVariant} from "@/components/generics/types/TBtnVariant";
import {PropType} from "vue";


export const ActionBtnProps = {
    confirmText: {
        type: String,
        default: 'Save'
    },
    confirmColor: {
        type: String,
        default: 'trtTealGreen'
    },
    confirmVariant: {
        type: String as PropType<TBtnVariant>,
        default: 'flat'
    },
    confirmDisabled: {
        type: Boolean,
        default: false
    },
    cancelText: {
        type: String,
        default: 'Cancel'
    },
    cancelColor: {
        type: String,
        default: 'primary'
    },
    cancelVariant: {
        type: String as PropType<TBtnVariant>,
        default: 'outlined'
    },
    cancelDisabled: {
        type: Boolean,
        default: false
    },
    confirm: {
        type: Boolean,
        default: true
    },
    cancel: {
        type: Boolean,
        default: true
    },
    confirmIsLoading: {
        type: Boolean,
        default: false
    },
    cancelIsLoading: {
        type: Boolean,
        default: false
    }
}